'use client';

import { FC } from 'react';
import Image from 'next/image';
import { activeStar, dimStar } from '../assets';

export type RatingProps = {
    value: number;
    max?: number;
    size?: number;
};

const clamp = (value: number, min: number, max: number): number => {
    return Math.min(max, Math.max(min, value));
};

const Rating: FC<RatingProps> = ({ value, max = 5, size = 10 }) => {
    const normalizedValue = Number.isFinite(value) ? value : 0;
    const stars = new Array(max).fill(false);

    return (
        <div
            className="flex flex-row gap-0.5"
            role="img"
            aria-label={`Оценка ${normalizedValue.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} из ${max}`}
        >
            {stars.map((_, index) => {
                const starFill = clamp(normalizedValue - index, 0, 1) * 100;

                return (
                    <span key={index} className="relative inline-block shrink-0" style={{ width: size, height: size }}>
                        <Image src={dimStar} alt="" width={size} height={size} />
                        {starFill > 0 && (
                            <span className="absolute inset-0 overflow-hidden" style={{ width: `${starFill}%` }}>
                                <Image src={activeStar} alt="" width={size} height={size} className="max-w-none" />
                            </span>
                        )}
                    </span>
                );
            })}
        </div>
    );
};

export default Rating;
